import React from 'react';
import './Slogan-styles.css';

export default function Slogan() {
    return (
        <>
        <div className="aboutme css-typing">
            <p className="title">Software Quality Assurance Engineer
            </p><br></br><br></br> <br></br>
            <p className="hi">Hey, You Awesome Humans!
            </p> <br></br> <br></br>
            {/* <p className="name">I am Shneha Paudyal </p>  */}
        </div>   
        {/* <div className="container-card">
         <p className="warning">WARNING!!! This is a QA's portfolio that doesn't mean its error free. </p>
         <p> You were warned </p>
        </div> */}
</>
    );
}
